import React from "react";
import { Box } from "@mui/material";

interface SectionBackgroundProps {
  variant?: "default" | "paper";
}

const SectionBackground: React.FC<SectionBackgroundProps> = ({
  variant = "default",
}) => {
  const baseColor = variant === "paper" ? "#141b3d" : "#0a0e27";

  return (
    <>
      {/* Subtle animated gradient */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: baseColor,
          zIndex: 0,
        }}
      />

      {/* Subtle moving circles */}
      <Box
        sx={{
          position: "absolute",
          top: "10%",
          left: "5%",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0, 168, 255, 0.05) 0%, transparent 70%)",
          animation: "floatSlow 20s ease-in-out infinite",
          "@keyframes floatSlow": {
            "0%, 100%": {
              transform: "translate(0, 0) scale(1)",
            },
            "50%": {
              transform: "translate(30px, -30px) scale(1.1)",
            },
          },
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: "10%",
          right: "10%",
          width: "400px",
          height: "400px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0, 102, 204, 0.05) 0%, transparent 70%)",
          animation: "floatSlow2 25s ease-in-out infinite",
          "@keyframes floatSlow2": {
            "0%, 100%": {
              transform: "translate(0, 0) scale(1)",
            },
            "50%": {
              transform: "translate(-40px, 20px) scale(1.15)",
            },
          },
          zIndex: 0,
        }}
      />

      {/* Subtle grid overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            linear-gradient(rgba(0, 168, 255, 0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 168, 255, 0.02) 1px, transparent 1px)
          `,
          backgroundSize: "60px 60px",
          opacity: 0.5,
          zIndex: 0,
        }}
      />
    </>
  );
};

export default SectionBackground;
